import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
    ctnPrompt: {
        border: '1px solid gray',
        width: '400px',
        // minHeight: '400px',
        background: '#FFFFFF',
        borderRadius: '15px'
    },
    txtTitleDelete: {
        fontFamily: 'Gellix',
        fontSize: '24px',
        fontWeight: 700,
        padding: '15px 0px 0px 25px',
        textAlign: 'left',
    },
    txtTitleDelete_ar: {
        fontFamily: 'TheSansArab',
        fontSize: '24px',
        fontWeight: 700,
        padding: '15px 25px 0px 0px',
        textAlign: 'right',
    },
    ctnImage: {
        border: '1px solid transparent',
        width: '100px',
        height: '100px',
        margin: '50px auto 30px',
    },
    txtAskDeletionCar: {
        fontFamily: 'Gellix',
        fontSize: '18px',
        fontWeight: 600,
        padding: '0px 8px 0px 8px',
    },
    txtAskDeletionCar_ar: {
        fontFamily: 'TheSansArab',
        fontSize: '18px',
        fontWeight: 600,
        padding: '0px 8px 0px 8px',
    },
    confirmeAskDeletionCar: {
        marginTop: '5px',
        fontFamily: 'Gellix',
        fontSize: '17px',
        fontWeight: 500,
        padding: '0px 9px 0px 9px',
    },
    confirmeAskDeletionCar_ar: {
        marginTop: '5px',
        fontFamily: 'TheSansArab',
        fontSize: '17px',
        fontWeight: 500,
        padding: '0px 9px 0px 9px',
    },
    ctnTable: {
        margin: '20px auto',
        width: '100%',
        border: '1px solid transparent',
        textAlign: 'center',
    },
    btnTable: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    btnCancel: {
        fontFamily: 'Gellix',
        fontSize: '17px',
        fontWeight: 700,
        color: '#6316DB',
        border: '1px solid #C4C0D3',
        padding: '10px 45px 10px 45px',
        borderRadius: '22px',
        cursor: 'pointer'
    },
    btnCancel_ar: {
        fontFamily: 'TheSansArab',
        fontSize: '17px',
        fontWeight: 700,
        color: '#6316DB',
        border: '1px solid #C4C0D3',
        padding: '10px 45px 10px 45px',
        borderRadius: '22px',
        cursor: 'pointer'
    },
    btnApply: {
        fontFamily: 'Gellix',
        fontSize: '17px',
        fontWeight: 700,
        color: '#FFFFFF',
        border: '1px solid',
        padding: '10px 40px 10px 40px',
        borderRadius: '22px',
        cursor: 'pointer'
    },
    btnApply_ar: {
        fontFamily: 'TheSansArab',
        fontSize: '17px',
        fontWeight: 700,
        color: '#FFFFFF',
        border: '1px solid',
        padding: '10px 40px 10px 40px',
        borderRadius: '22px',
        cursor: 'pointer'
    }
}));